import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TopHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center px-5 py-3 border-b-2 border-[var(--hover)] bg-[var(--background)] shadow-sm">
      <button
        onClick={() => navigate(-1)}
        className="p-2 rounded-lg border-2 border-[var(--hover)] hover:bg-[var(--hover)] transition"
      >
        <ArrowLeft className="w-5 h-5 text-[var(--subtext)]" />
      </button>

      <div className="text-[var(--text)] font-semibold text-base select-none">
        CHANGE PASSWORD
      </div>

      <button
        onClick={() => navigate(-1)}
        className="p-2 rounded-lg border border-[var(--background)]  transition relative"
      >
        <ArrowLeft className="w-5 h-5 text-[var(--background)]" />
      </button>
    </div>
  );
}
